module.exports = __webpack_public_path__ + "img/empty-bg.92a8985b.png";